import { Flex, PanelHeader, Text } from "@coaching-culture/ui";
import React from "react";

export type WidgetPanelHeaderProps = {
  title: React.ReactNode;
  /** Shown at the right: the widget's actions, toggles or filters. */
  children?: React.ReactNode;
};

/** The title row of a dashboard / team-member widget card. */
export function WidgetPanelHeader({ title, children }: WidgetPanelHeaderProps) {
  return (
    <PanelHeader
      justifyContent="space-between"
      flexWrap="wrap"
      height="auto"
      minHeight={52}
      style={{ gap: 12 }}
    >
      <Text as="h2" m={0} fontSize="title" fontWeight={600}>
        {title}
      </Text>
      {children != null && (
        <Flex alignItems="center" flexWrap="wrap" style={{ gap: 8 }}>
          {children}
        </Flex>
      )}
    </PanelHeader>
  );
}
